var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38156",
    d: "M.814 0A.7.7 0 0 1 1.5.726l-.117 13.962a.729.729 0 0 1-.7.739A.7.7 0 0 1 0 14.7L.117.739A.729.729 0 0 1 .814 0z",
    transform: "rotate(45 2.626 19.996)",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38157",
    d: "M.686 0a.729.729 0 0 1 .7.739L1.5 14.7a.7.7 0 0 1-.685.726.729.729 0 0 1-.7-.739L0 .727A.7.7 0 0 1 .686 0z",
    transform: "rotate(-45 8.145 -2.282)",
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelIc);
export default __webpack_public_path__ + "static/media/del_ic.ae79e25e78448951ab44a1127d3a92d9.svg";
export { ForwardRef as ReactComponent };